import { render, staticRenderFns } from "./CImg.vue?vue&type=template&id=2ff083a4&"
import script from "./CImg.vue?vue&type=script&lang=js&"
export * from "./CImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports